<script setup lang="ts">
import {ref} from "vue";

interface Props {
  dta: string
}
const props = defineProps<Props>()

const isDialogOpen = ref(false)
</script>

<template>
    <v-dialog
        v-model="isDialogOpen"
        max-width="500"
        overlay-opacity="0.1"
    >
        <template #activator="{ props: attrs }">
            <v-btn
                v-bind="attrs"
                size="small"
                variant="flat"
                rounded="lg"
                class="border text-none text-caption btn-outlined mr-5 bg-grey-lighten-4 rounded"
            >
                <span class="font-weight font-weight-medium text-grey-darken-3">View DTA</span>
                <v-icon
                    right
                    class="ml-1"
                >
                    mdi-file-document-outline
                </v-icon>
            </v-btn>
        </template>

        <v-card
            :flat="true"
            rounded="lg"
            class="border"
        >
            <v-card-title class="font-weight-bold border-bottom text-body-2 bg-grey-lighten-4 border-b">
                Processing activity record
                <v-btn
                    variant="plain"
                    size="x-small"
                    icon="mdi-close"
                    class="float-end"
                    @click="isDialogOpen = false"
                />
            </v-card-title>

            <v-card-text class="pt-5 black--text">
                <p class="mb-0 text-body-2">
                    {{ props.dta }}
                </p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>
